import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@material-ui/core';


class InformationDialog extends Component {


        render() {

            const { open, handleClose, handleLogout } = this.props

            return (
                <div>
                    
                    <Dialog
                        disableBackdropClick
                        disableEscapeKeyDown
                        open={open}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">Logout</DialogTitle>

                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure want to logout? 
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>

                                <Button onClick={  handleClose } color="primary">
                                    Cancel
                                </Button>

                                <Button onClick={ handleLogout } color="primary">
                                    Logout
                                </Button>

                            </DialogActions>

                    </Dialog>

                </div>
            )

        }

}

const styles = ({
    content: {
        display: 'flex',
        minHeight: '10vh',
        justifyContent: 'center'
    }
})

InformationDialog.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(InformationDialog)